import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-redirecionamento-externo',
  templateUrl: './redirecionamento-externo.component.html',
  styleUrls: ['./redirecionamento-externo.component.scss']
})
export class RedirecionamentoExternoComponent implements OnInit {
  hash: string;
  isLoading = true;
  params: any;

  constructor(private route: ActivatedRoute, private router: Router, private authService: AuthService) { }

  ngOnInit() {
    this.hash = this.route.snapshot.params['hash'];
    this.acessoExterno();
  }

  acessoExterno() {
    this.params = window.location.href.lastIndexOf('?') + 0 != -1 ? window.location.href.slice(window.location.href.lastIndexOf('?') + 0) : "";

    this.authService.acessoExterno(this.hash)
      .subscribe(response => {

        StorageService.setExternalAccess({
          desc: response.descricaoOrigem,
          retorno: response.urlRetorno,
          token: response.token,
          cpfObrigatorio : response.cpfObrigatorio,
          destino: `${response.urlDestino}${this.params}`
        });

        if (response.error) {
          return this.isLoading = false;
        } else {
          return this.router.navigateByUrl(`${response.urlDestino}${this.params}`);
        }
      },
      (err: HttpErrorResponse) => {
        this.isLoading = false;
      });
  }
}
